<template>
    <div class="SubscriptionFinalizePage">
        <SiteHeader/>

        <Container>
            <Card v-if="pending">
                <p>Please wait while we finalize your subscription...</p>
                <Icon name="spinner" pulse/>
            </Card>
            <Card v-else>
                <h2>Done! You can now start using DumpTek.</h2>
                <p>You will be redirected automatically...</p>
                <Icon class="green" name="check-circle"/>
            </Card>
        </Container>

        <SiteFooter/>
    </div>
</template>


<script>
import { mapState } from 'vuex';
import * as api from '@/api';
import Card from '@/components/Card';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

export default {
    name: 'SignupSubscriptionFinalizePage',

    components: {
        SiteHeader,
        SiteFooter,
        Card,
    },

    data: () => ({
        timeout: null,
        pending: true,
    }),

    computed: mapState('company', ['subscription']),

    mounted() {
        this.refresh();
    },

    beforeDestroy() {
        clearTimeout(this.timeout);
    },

    methods: {
        async refresh() {
            await this.$store.dispatch('company/fetchOverview');

            if (!this.subscription) {
                this.timeout = setTimeout(() => this.refresh(), 1500);
                return;
            }

            this.pending = false;

            await this.$store.dispatch('auth/refreshUser');
            setTimeout(() => this.$router.replace('/company/dashboard'), 2500);
        }
    },
}
</script>


<style lang="scss" scoped>
@import 'globals.scss';

.SubscriptionFinalizePage {
    display: flex;
    flex-wrap: wrap;
    min-height: 100vh;

    .Container {
        margin-top: 30px;
        margin-bottom: 80px;
        text-align: center;

        h1 {
            @extend %display-subtitle;
            margin-bottom: 30px;
        }
    }

    .Card {
        max-width: 600px;
        margin: 0 auto;

        p {
            @extend %display-description;
        }

        button {
            margin-top: 40px;
        }
    }

    .Icon {
        margin-top: 40px;
        font-size: 48px;
        color: $blue-color;

        &.green {
            color: $green-color;
        }
    }

    .SiteFooter {
        align-self: flex-end;
    }
}
</style>
